module.exports = __webpack_public_path__ + "img/ic_buildings_and_contents.309d38ef.svg";